// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ServicesList_wrapper__2cmSe","item":"ServicesList_item__uLype","header":"ServicesList_header__3e_Lz"};